/** Packages **/
import React, { useEffect, useMemo } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import { common } from '../../data/constants';
import oidcAuthConfig from '../../oidcAuthConfig';
import './styles.scss';

// Remove static menu and label loading. Use context below.
const DrawerMenu = props => {
  const { labels } = useLanguage();
  // Build menu dynamically from context labels - useMemo ensures it updates when labels change
  const menu = useMemo(() => [
    { id: 1, key: 'menuItem-1', label: labels.menu?.HOME || 'HOME', ref: '/home' },
    { id: 2, key: 'menuItem-2', label: labels.menu?.IMPERSONATE || 'IMPERSONATE', ref: '/impersonate' },
    { id: 3, key: 'menuItem-3', label: labels.menu?.CREW_GROUP_DEFAULT || 'CREW GROUP DEFAULT', ref: '/crew-group-default' },
    { id: 4, key: 'menuItem-4', label: labels.menu?.HISTORY || 'HISTORY', ref: '/history' },
    { id: 5, key: 'menuItem-5', label: labels.menu?.REPORTS || 'REPORTS', ref: '/reports' },
    { id: 6, key: 'menuItem-6', label: labels.menu?.SETTINGS || 'SETTINGS', ref: '/settings' },
    { id: 7, key: 'menuItem-7', label: labels.menu?.SIGN_OUT || 'SIGN OUT', ref: 'SIGN_OUT' },
    { id: 8, key: 'menuItem-8', label: labels.menu?.HELP || 'HELP', ref: '/help' }
  ], [labels]);
  const commonLabels = labels.commonLabels || {};
  const menuItemStyles = {
    paddingLeft: '30px',
    fontSize: '13px',
    color: '#4C4C4C',
    margin: '20px 0',
    height: '40px'
  };
  const handleOpen = props.handleOpen;
  const staffId = props.user ? props.user.staffId : '';

  // Admin-only menu items to exclude for non-admin users
  const adminOnlyRoutes = ['/impersonate', '/crew-group-default'];

  let menuItem;
  if (staffId === commonLabels.ADMIN || sessionStorage.getItem(oidcAuthConfig.isAdminFieldName) === oidcAuthConfig.isAdminFieldValue) {
    menuItem = menu;
  } else {
    menuItem = menu.filter(item => !adminOnlyRoutes.includes(item.ref));
  }

  const openInNewTab = (url) => {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost') {
      window.location.href = window.helpUrl;
    } else {
      window.open(url, "_blank", "noreferrer");
    }

  }

  useEffect(() => {
    if(menuItem) {
      const temp = document.getElementById(`menu_item_${menuItem[0].id}`).click()
    }
  }, [])

  const menuItems = menuItem.map((item, index) => {
    if (item.ref === common.SIGN_OUT) {
      return (
        <MenuItem
          id={`menu_item_${item.id}`}
          key={item.key}
          onClick={handleOpen}
          style={menuItemStyles}
          className={'menu-item'}
        >
          {item.label}
        </MenuItem>
      );
    }

    if (item.ref === '/help') {
      return (
          <MenuItem
            id={`menu_item_${item.id}`}
            style={menuItemStyles}
            className={'menu-item'}
            onClick={() => {
              openInNewTab('/assets/help/Content/Home.htm')
              props.handleMenuChange
            }}
          >
            {item.label}
          </MenuItem>
      );
    }
    return (
      <Link key={item.key} to={item.ref} id={`menu_item_${item.id}`}>
        <MenuItem
          style={menuItemStyles}
          className={'menu-item'}
          onClick={props.handleMenuChange}
        >
          {item.label}
        </MenuItem>
      </Link>
    );
  });
  return <MenuList className='Drawer-Menu'>{menuItems}</MenuList>;
};

DrawerMenu.propTypes = {
  handleOpen: PropTypes.func,
  handleMenuChange: PropTypes.func,
  user: PropTypes.object.isRequired,
  staff: PropTypes.object.isRequired
};

DrawerMenu.defaultProps = {
  handleOpen: () => {},
  handleMenuChange: () => {}
};

export default DrawerMenu;
